var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.2 34.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_react") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.87,30.83c-9.49,0-19.1-2.33-19.1-6.79s9.61-6.78,19.1-6.78S44,19.59,44,24,34.36,30.83,24.87,30.83Zm0-11.57C14.27,19.26,7.77,22,7.77,24s6.5,4.79,17.1,4.79S42,26,42,24,35.46,19.26,24.87,19.26Z",
    transform: "translate(-5.77 -6.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.83,41c-4,0-9.69-6.38-13.84-13.56a44.46,44.46,0,0,1-5-12.22c-.88-4-.41-6.69,1.37-7.71C19.18,5.28,26,12.43,30.75,20.65h0c4.74,8.22,7.53,17.7,3.67,19.93A3.15,3.15,0,0,1,32.83,41ZM16.92,9.09a1.11,1.11,0,0,0-.6.15c-.67.38-1.18,2.07-.42,5.56a42.59,42.59,0,0,0,4.82,11.64c5.29,9.17,11,13.41,12.7,12.41s.89-8-4.41-17.2h0C24.22,13.35,19.13,9.09,16.92,9.09Z",
    transform: "translate(-5.77 -6.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84,41.51a3,3,0,0,1-1.34-.3c-1.84-.9-2.5-3.52-1.91-7.6a44.78,44.78,0,0,1,4.17-12.54h0a44.76,44.76,0,0,1,7.31-11c2.85-3,5.33-4.08,7.17-3.18,4,2,1.89,11.61-2.27,20.14a44.48,44.48,0,0,1-7.31,11C21.46,40.34,19.48,41.51,17.84,41.51ZM31.91,8.58c-.86,0-2.36.73-4.39,2.86a42.85,42.85,0,0,0-7,10.51h0a42.7,42.7,0,0,0-4,12c-.51,3.53.11,5.18.8,5.51s2.38-.18,4.85-2.76a42.56,42.56,0,0,0,7-10.51c4.64-9.52,5-16.59,3.19-17.46A1,1,0,0,0,31.91,8.58Z",
    transform: "translate(-5.77 -6.58)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1,
    cy: 17.47,
    r: 3.27
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReact);
export default __webpack_public_path__ + "static/media/ic_react.1dd99ff76bc322ee22a5af31a602f011.svg";
export { ForwardRef as ReactComponent };